import React, { createContext, forwardRef, useContext, useId } from 'react';
import { Box, Dialog, DialogActions, DialogContent, IconButton, Tooltip, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';

const DialogContext = createContext({});

const Modal = ({ show, onHide, size, centered, scrollable, backdrop, keyboard = true, className = '', dialogClassName = '', children, onEnter, onEntered, onExit, onExited, ...props }) => {
  const titleId = useId();
  return (
    <DialogContext.Provider value={{ onHide, titleId }}>
      <Dialog open={!!show} onClose={(event, reason) => { if (reason === 'backdropClick' && backdrop === 'static') return; onHide?.(); }}
        disableEscapeKeyDown={!keyboard} hideBackdrop={backdrop === false} fullWidth
        maxWidth={({ sm: 'xs', lg: 'md', xl: 'lg' })[size] || 'sm'}
        className={'sugi-dialog ' + className} aria-labelledby={titleId}
        PaperProps={{ className: 'sugi-dialog-paper ' + dialogClassName }}
        TransitionProps={{ onEnter, onEntered, onExit, onExited }} {...props}>
        {children}
      </Dialog>
    </DialogContext.Provider>
  );
};

const ModalHeader = ({ closeButton, children, className = '', ...props }) => {
  const { onHide } = useContext(DialogContext);
  return <Box component="header" className={'modal-header sugi-dialog-header ' + className} {...props}>
    <Box sx={{ minWidth: 0, flex: 1 }}>{children}</Box>
    {closeButton && <Tooltip title="Cerrar"><span><IconButton onClick={onHide} disabled={!onHide} aria-label="Cerrar" size="small"><Close /></IconButton></span></Tooltip>}
  </Box>;
};
const ModalTitle = ({ children, className = '', ...props }) => {
  const { titleId } = useContext(DialogContext);
  return <Typography component="h2" variant="h6" id={titleId} className={'sugi-dialog-title ' + className.replace(/\btext-white\b/g, '')} {...props}>{children}</Typography>;
};
Modal.Header = ModalHeader;
Modal.Title = ModalTitle;
Modal.Body = forwardRef(({ children, className = '', ...props }, ref) => <DialogContent ref={ref} className={'modal-body sugi-dialog-body ' + className} {...props}>{children}</DialogContent>);
Modal.Footer = ({ children, className = '', ...props }) => <DialogActions className={'modal-footer sugi-dialog-footer ' + className} {...props}>{children}</DialogActions>;
Modal.Body.displayName = 'Modal.Body';
export default Modal;
